import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, ExternalLink, Star, FileText, Image } from 'lucide-react';
import './SourcesSlide.css';

function SourcesSlide({ showNotes }) {
  const [activeTab, setActiveTab] = useState('text');

  // ORIGINAL TEXT SOURCES - NICHT GEÄNDERT
  const textSources = [
    {
      name: 'Bundeszentrale für politische Bildung (bpb)',
      topic: 'Rechtsextreme Diskursstrategien',
      fullUrl: 'https://www.bpb.de/themen/rechtsextremismus/dossier-rechtsextremismus/551839/rechtsextreme-diskursstrategien/',
      display: 'bpb.de/.../diskursstrategien',
      highlight: true
    },
    {
      name: 'Tagesschau.de',
      topic: 'Proteste nach Koran-Verbrennung',
      fullUrl: 'https://www.tagesschau.de/ausland/europa/tuerkei-proteste-koran-101.html',
      display: 'tagesschau.de/.../tuerkei-proteste-koran',
    },
    {
      name: 'New York Times',
      topic: "Trump's \"Dining With Nick Fuentes\"",
      fullUrl: 'https://www.nytimes.com/2022/11/25/us/politics/trump-nick-fuentes-dinner.html',
      display: 'nytimes.com/.../trump-nick-fuentes'
    },
    {
      name: 'Amnesty International',
      topic: 'Evidence of war crimes in Gaza',
      fullUrl: 'https://www.amnesty.org/en/latest/news/2023/10/damning-evidence-of-war-crimes-as-israeli-attacks-wipe-out-entire-families-in-gaza/',
      display: 'amnesty.org/.../evidence-war-crimes-gaza'
    },
    {
      name: 'Internationaler Gerichtshof (IGH)',
      topic: 'South Africa v. Israel (Genocide Convention)',
      fullUrl: 'https://www.icj-cij.org/case/192',
      display: 'icj-cij.org/case/192'
    },
    {
      name: 'Verfassungsschutz',
      topic: 'Radikalisierung junger Akteure',
      fullUrl: 'https://www.verfassungsschutz.de/SharedDocs/hintergruende/DE/rechtsextremismus/radikalisierung-junter-akteure.html',
      display: 'verfassungsschutz.de/.../radikalisierung-junter-akteure'
    },
    {
      name: 'The Guardian',
      topic: 'Viktor Orbán CPAC Speech',
      fullUrl: 'https://www.theguardian.com/world/2023/may/04/viktor-orban-cpac-hungary-speech-liberalism-virus',
      display: 'theguardian.com/.../orban-cpac-speech'
    },
    {
      name: 'Reuters',
      topic: 'Israeli judicial reform protests',
      fullUrl: 'https://www.reuters.com/world/middle-east/israeli-protests-ignite-after-parliament-passes-key-judicial-reform-bill-2023-07-24/',
      display: 'reuters.com/.../israeli-protests-ignite'
    },
  ];

  // IMAGE SOURCES - NEU HINZUGEFÜGT
  const imageSources = [
    {
      name: 'Wikipedia Commons',
      topic: 'Rasmus Paludan - Koran-Verbrennung 2023',
      fullUrl: 'https://en.wikipedia.org/wiki/2023_Quran_burnings_in_Sweden#/media/File:Rasmus_Paludan_burning_the_Koran_2023-01-21_(2).jpg',
      display: 'wikipedia.org/.../Rasmus_Paludan'
    },
    {
      name: 'The Guardian',
      topic: 'Nick Fuentes - Trump Dinner',
      fullUrl: 'https://www.theguardian.com/us-news/2022/nov/28/donald-trump-shied-away-from-criticising-nick-fuentes',
      display: 'theguardian.com/.../nick-fuentes'
    },
    {
      name: 'Wikipedia Commons',
      topic: 'Tucker Carlson - Portrait',
      fullUrl: 'https://en.wikipedia.org/wiki/Tucker_Carlson#/media/File:Tucker_Carlson_-_54820343443_(cropped).jpg',
      display: 'wikipedia.org/.../Tucker_Carlson'
    },
    {
      name: 'The Guardian',
      topic: 'Tommy Robinson - Religious Gathering',
      fullUrl: 'https://www.theguardian.com/uk-news/2025/dec/18/how-tommy-robinson-has-completely-missed-the-christian-message',
      display: 'theguardian.com/.../tommy-robinson'
    },
    {
      name: 'The Guardian / EPA',
      topic: 'Sławomir Mentzen - Campaign Photo',
      fullUrl: 'https://www.theguardian.com/world/2025/may/17/poland-presidential-election-candidates-slawomir-mentzen-adrian-zandberg',
      display: 'theguardian.com/.../mentzen-campaign'
    },
    {
      name: 'Business Insider PL / Forum',
      topic: 'Grzegorz Braun - Pressekonferenz',
      fullUrl: 'https://businessinsider.com.pl/gospodarka/konfederacja-korony-polskiej-grzegorza-brauna-trzecia-sila-w-sejmie-polexit-i/zzgw7n5',
      display: 'businessinsider.com.pl/.../braun'
    },
    {
      name: 'Népszava',
      topic: 'László Toroczkai - Mi Hazánk',
      fullUrl: 'https://nepszava.hu/3237365_toroczkai-laszlo-afd-budapest-latogtas-targyalas',
      display: 'nepszava.hu/.../toroczkai'
    },
    {
      name: 'dpa / GMX.at',
      topic: 'Viktor Orbán - EU-Kampagne',
      fullUrl: 'https://www.gmx.at/magazine/politik/viktor-orban-kuendigt-anti-bruessel-kampagne-33590242',
      display: 'gmx.at/.../orban'
    },
    {
      name: 'profil.at / picturedesk',
      topic: 'Martin Sellner - Identitäre Bewegung',
      fullUrl: 'https://www.profil.at/oesterreich/martin-sellners-geheimplan-voelkische-traeume/402738244',
      display: 'profil.at/.../sellner'
    },
    {
      name: 'Deutschlandfunk / picture alliance',
      topic: 'Björn Höcke - AfD Thüringen',
      fullUrl: 'https://www.deutschlandfunk.de/landtagswahl-thueringen-2024-100.html',
      display: 'deutschlandfunk.de/.../hoecke'
    },
    {
      name: 'meinbezirk.at',
      topic: 'Herbert Kickl - Facebook Post',
      fullUrl: 'https://www.meinbezirk.at/c-politik/so-reagiert-die-oevp-auf-kickls-facebook-post_a7139244#gallery=null',
      display: 'meinbezirk.at/.../kickl'
    },
    {
      name: 'The Guardian',
      topic: 'Itamar Ben-Gvir - Israel Election',
      fullUrl: 'https://www.theguardian.com/world/2022/oct/29/israel-election-far-right-itamar-ben-gvir',
      display: 'theguardian.com/.../ben-gvir'
    },
    {
      name: 'CBC News',
      topic: 'Bezalel Smotrich & Netanyahu',
      fullUrl: 'https://www.cbc.ca/news/politics/ottawa-condemns-smotrich-remarks-palestinian-people-1.6786403',
      display: 'cbc.ca/.../smotrich-remarks'
    },
    {
      name: 'Tagesschau',
      topic: 'Israel Proteste gegen Regierung',
      fullUrl: 'https://www.tagesschau.de/ausland/israel-gesellschaft-gespalten-100.html',
      display: 'tagesschau.de/.../israel-proteste'
    },
    {
      name: 'Statista',
      topic: 'Far-Right Map in Europe (2023)',
      fullUrl: 'https://www.statista.com/chart/6852/seats-held-by-far-right-parties-in-europe/',
      display: 'statista.com/.../far-right-europe'
    },
    {
      name: 'Fox News',
      topic: 'Charlie Kirk - Photo Gallery',
      fullUrl: 'https://www.foxnews.com/us/photo-gallery-charlie-kirk',
      display: 'foxnews.com/.../charlie-kirk'
    },
    {
      name: 'ADL',
      topic: 'Nick Fuentes - Profile',
      fullUrl: 'https://www.adl.org/resources/article/nicholas-j-fuentes-five-things-know',
      display: 'adl.org/.../nick-fuentes'
    },
    {
      name: 'IMDB',
      topic: 'Rasmus Paludan - Profile',
      fullUrl: 'https://www.imdb.com/name/nm12463536/',
      display: 'imdb.com/.../rasmus-paludan'
    },
    {
      name: 'Der Spiegel',
      topic: 'Proteste Koran-Verbrennungen',
      fullUrl: 'https://www.spiegel.de/politik/irak-tausende-protestieren-gegen-koranverbrennungen-in-daenemark-und-schweden-a-e6dd77b9-20d0-449b-b3a6-5b05a32a94f7',
      display: 'spiegel.de/.../koran-proteste'
    },
    {
      name: 'Getty Images',
      topic: 'Donald Tusk - Prime Minister',
      fullUrl: 'https://www.gettyimages.fr/photos/donald-tusk',
      display: 'gettyimages.fr/.../donald-tusk'
    },
    {
      name: 'Hungary Today',
      topic: 'CPAC Hungary Event - Orban',
      fullUrl: 'https://hungarytoday.hu/pm-orban-at-cpac-hungary-has-antidote-for-progressive-dominance/',
      display: 'hungarytoday.hu/.../cpac-hungary'
    },
        {
      name: 'Daily Mail',
      topic: 'Elon Musk - Far-Right Twitter Promotion',
      fullUrl: 'https://www.dailymail.co.uk/news/article-14381309/Far-Right-British-Twitter-Inevitable-West-Elon-Musk-sleuths-identity.html',
      display: 'dailymail.co.uk/.../elon-musk-inevitable-west'
    },
    {
      name: 'Times of Israel',
      topic: 'Itamar Ben-Gvir - Profile',
      fullUrl: 'https://www.timesofisrael.com/topic/itamar-ben-gvir/',
      display: 'timesofisrael.com/.../ben-gvir'
    },
    {
      name: 'Getty Images',
      topic: 'Bezalel Smotrich - Editorial',
      fullUrl: 'https://www.gettyimages.de/fotos/bezalel-smotrich',
      display: 'gettyimages.de/.../smotrich'
    },
    {
      name: 'Human Rights Watch',
      topic: 'Internationaler Strafgerichtshof',
      fullUrl: 'https://www.hrw.org/de/news/2025/04/04/die-eu-sollte-den-internationalen-strafgerichtshof-istgh-verteidigen',
      display: 'hrw.org/.../istgh'
    },
    {
      name: 'Gemini AI',
      topic: 'Kritik vs. Propaganda / Doppelmoral',
      fullUrl: '#',
      display: 'KI-generierte Grafiken'
    },
        {
      name: 'Gemini AI',
      topic: 'Far-Right Map in Europe (2025)',
      fullUrl: '#',
      display: 'KI-generierte Grafiken: Die Statistik wurde aktualisiert für 2025'
    },
    
    {
      name: 'ChatGPT',
      topic: 'Fazit-Bild / Protest Signs',
      fullUrl: '#',
      display: 'KI-generierte Grafiken'
    }
  ];

  const currentSources = activeTab === 'text' ? textSources : imageSources;

  return (
    <div className="slide sources-slide">
      <div className="sources-layout">
        {/* Header */}
        <div className="sources-header">
          <motion.span
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="section-label"
          >
            Referenzen
          </motion.span>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="slide-title"
          >
            Quellen
          </motion.h2>
        </div>

        {/* Tabs */}
        <motion.div 
          className="sources-tabs"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <button
            className={`tab-button ${activeTab === 'text' ? 'active' : ''}`}
            onClick={() => setActiveTab('text')}
          >
            <FileText size={18} />
            Textquellen
            <span className="tab-count">{textSources.length}</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'images' ? 'active' : ''}`}
            onClick={() => setActiveTab('images')}
          >
            <Image size={18} />
            Bildquellen
            <span className="tab-count">{imageSources.length}</span>
          </button>
        </motion.div>

        {/* Sources Content */}
        <div className="sources-content-container">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              className="sources-grid"
              initial={{ opacity: 0, x: activeTab === 'text' ? -20 : 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: activeTab === 'text' ? 20 : -20 }}
              transition={{ duration: 0.3 }}
            >
              {currentSources.map((source, index) => (
                <motion.div
                  key={index}
                  className={`source-card ${source.highlight ? 'highlighted' : ''} ${activeTab === 'images' ? 'image-source' : ''}`}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.03 }}
                  whileHover={{ scale: 1.02, y: -2 }}
                >
                  <div className="source-icon">
                    {source.highlight ? (
                      <Star size={16} />
                    ) : activeTab === 'images' ? (
                      <Image size={16} />
                    ) : (
                      <BookOpen size={16} />
                    )}
                  </div>
                  <div className="source-content">
                    <h4 className="source-name">{source.name}</h4>
                    <p className="source-topic">{source.topic}</p>
                    {source.fullUrl !== '#' ? (
                      <a 
                        href={source.fullUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="source-url"
                      >
                        <ExternalLink size={10} />
                        {source.display}
                      </a>
                    ) : (
                      <span className="source-url no-link">
                        {source.display}
                      </span>
                    )}
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </AnimatePresence>

          {/* AI Note for Images Tab */}
          {activeTab === 'images' && (
            <motion.div 
              className="ai-note"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <span className="ai-note-icon">🤖</span>
              <span className="ai-note-text">
                Einige Grafiken wurden mit KI-Tools (Gemini AI, ChatGPT) erstellt und sind entsprechend gekennzeichnet.
              </span>
            </motion.div>
          )}

          {/* Recommendation Box */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="recommendation-box"
          >
            <div className="recommendation-icon">💡</div>
            <div className="recommendation-content">
              <h4>Empfehlung zum Nachlesen</h4>
              <p>
                Die <strong>Bundeszentrale für politische Bildung (bpb)</strong> ist 
                kostenlos und seriös. Perfekt für tiefergehende Recherche zu allen 
                Themen dieser Präsentation.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {showNotes && (
        <div className="speaker-notes">
          <strong>📚 Zusatzinfos für Leser:</strong><br/>
          <strong>Über die Quellen:</strong><br/>
          Alle verwendeten Quellen sind öffentlich zugänglich und stammen von etablierten 
          Nachrichtenorganisationen, staatlichen Institutionen oder internationalen Organisationen.<br/><br/>
          <strong>Besonders empfohlen zum Nachlesen:</strong><br/>
          • <em>Bundeszentrale für politische Bildung (bpb):</em> Kostenlose, sachliche Informationen 
          zu allen politischen Themen, finanziert vom deutschen Staat<br/>
          • <em>Verfassungsschutz:</em> Offizielle Einschätzungen zu extremistischen Bewegungen<br/>
          • <em>ICJ (Internationaler Gerichtshof):</em> Offizielle Dokumente zu laufenden Verfahren<br/><br/>
          <strong>Hinweis:</strong> Die Links können sich ändern. Bei Problemen nach dem 
          Titel des Artikels + Quelle suchen.
        </div>
      )}
    </div>
  );
}

export default SourcesSlide;